(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5d03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5d03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("71MPf", function(module, exports) {

$parcel$export(module.exports, "initServicesList", () => $51de802038f49ab9$export$22e75ef7dd469ed8);
// import { setLinesWrapper } from "../modules/setLinesWrapper";
function $51de802038f49ab9$export$22e75ef7dd469ed8() {
    const servicesItems = document.querySelectorAll(".services-list-item");
    if (!servicesItems) return;
    servicesItems.forEach((item)=>{
        const line = item.querySelector(".services-list-item-line"), heading = item.querySelector("h3"), description = item.querySelector(".services-list-item-description > p"), button = item.querySelector(".button");
        let headingEls, descriptionEls;
        SplitText.create(heading, {
            type: "lines, words",
            mask: "lines",
            wordsClass: "word",
            linesClass: "line",
            autoSplit: true,
            onSplit: (self)=>{
                headingEls = heading.querySelectorAll(".word");
                gsap.set(headingEls, {
                    yPercent: 100
                });
            }
        });
        // const headingLines = new SplitType(heading, {
        //   types: "lines, words",
        //   tagName: "span",
        // });
        SplitText.create(description, {
            type: "lines",
            mask: "lines",
            linesClass: "line",
            autoSplit: true,
            onSplit: (self)=>{
                descriptionEls = description.querySelectorAll(".line");
                gsap.set(descriptionEls, {
                    yPercent: 100
                });
            }
        });
        // const descriptionLines = new SplitType(description, {
        //   types: "lines",
        //   tagName: "span",
        // });
        // setLinesWrapper(descriptionLines.lines, () => {
        //   descriptionEls = description.querySelectorAll(".line");
        //   gsap.set(descriptionEls, { yPercent: 100 });
        // });
        gsap.set(line, {
            scaleX: 0
        });
        gsap.set(button, {
            yPercent: 100
        });
        gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "top bottom-=20%",
                onEnter: ()=>{
                    const tl = gsap.timeline();
                    tl.to(line, {
                        scaleX: 1,
                        duration: 0.5,
                        ease: "expo.out"
                    }).to(headingEls, {
                        yPercent: 0,
                        stagger: 0.1,
                        duration: 0.5,
                        ease: "expo.out"
                    }, "-=0.25").to(descriptionEls, {
                        yPercent: 0,
                        stagger: 0.05,
                        ease: "expo.out"
                    }, "-=0.25").to(button, {
                        yPercent: 0,
                        duration: 0.3,
                        ease: "expo.out"
                    }, "-=0.25");
                }
            }
        });
    });
}

});

function $02e6656982d09cd6$export$cae331894b422b15() {
    const imagesWrapper = document.querySelector(".service-slider_inner");
    let images = imagesWrapper.querySelectorAll(".service-slider_item");
    if (!images) return;
    const tl = gsap.timeline({
        repeat: -1,
        onComplete: ()=>{
            tl.seek(0);
        }
    });
    const lastImg = images[0].cloneNode(true);
    imagesWrapper.append(lastImg);
    images = imagesWrapper.querySelectorAll(".service-slider_item");
    images.forEach((img, i)=>{
        if (i === 0) return;
        tl.fromTo(img, {
            clipPath: "inset(50%)"
        }, {
            clipPath: "inset(0%)",
            duration: 1,
            delay: 1,
            ease: "expo.out"
        });
        tl.fromTo(img.querySelector(".service-slider_img"), {
            scale: 1.1
        }, {
            scale: 1,
            duration: 1,
            ease: "expo.out"
        }, "-=1");
    });
}



var $71MPf = parcelRequire("71MPf");
function $1339e159f4703240$export$e9e4c19fee2954d1(el, tag, className) {
    // Get the text content of the element
    const textContent = el.textContent;
    // Create a new element
    const element = document.createElement(tag);
    if (className) element.classList.add(className);
    // Set the text content of the element
    element.textContent = textContent;
    // Clear the original element's content
    el.textContent = "";
    // Append the element to the original element
    el.appendChild(element);
}


function $f0ff19698ac5025d$export$550809aa9e1ca17() {
    const lists = document.querySelectorAll(".text-rich-text.is-services-list ul");
    if (!lists) return;
    lists.forEach((list)=>{
        const items = list.querySelectorAll("li");
        if (!items) return;
        items.forEach((item)=>{
            (0, $1339e159f4703240$export$e9e4c19fee2954d1)(item, "div", "list-item-text");
            const line = document.createElement("div");
            line.classList.add("list-item-line");
            item.appendChild(line);
        });
        const lines = list.querySelectorAll(".list-item-line"), text = list.querySelectorAll(".list-item-text");
        gsap.set(lines, {
            xPercent: -100
        });
        gsap.set(text, {
            yPercent: 100
        });
        list.classList.add("ready");
        const tl = gsap.timeline({
            paused: true
        });
        tl.to(lines, {
            xPercent: 0,
            duration: 1,
            ease: "expo.Out",
            stagger: 0.1
        }).to(text, {
            yPercent: 0,
            duration: 1,
            ease: "expo.Out",
            stagger: 0.1
        }, 0.05);
        gsap.timeline({
            scrollTrigger: {
                trigger: list,
                start: "center bottom",
                once: true,
                onEnter: ()=>{
                    tl.play();
                }
            }
        });
    });
}


document.fonts.ready.then(()=>{
    (0, $02e6656982d09cd6$export$cae331894b422b15)();
    (0, $71MPf.initServicesList)();
    (0, $f0ff19698ac5025d$export$550809aa9e1ca17)();
});

})();
//# sourceMappingURL=services.js.map
